// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1sDWa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeView", ()=>TreeView);
parcelHelpers.export(exports, "TreeViewItem", ()=>TreeViewItem);
parcelHelpers.export(exports, "TreeViewItemContent", ()=>TreeViewItemContent);
parcelHelpers.export(exports, "TreeViewLoadMoreItem", ()=>TreeViewLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _actionMenu = require("./ActionMenu");
var _button = require("react-aria-components/Button");
var _centerBaseline = require("./CenterBaseline");
var _checkbox = require("./Checkbox");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _dndUtils = require("./dnd-utils");
var _dragPreview = require("./DragPreview");
var _icon = require("./Icon");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _progressCircle = require("./ProgressCircle");
var _slots = require("react-aria-components/slots");
var _tree = require("react-aria-components/Tree");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listView = require("./ListView");
var _content = require("./Content");
var _actionBar = require("./ActionBar");
var _useDOMRef = require("./useDOMRef");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _utils = require("./utils");
var _virtualizer = require("react-aria-components/Virtualizer");
const TreeRendererContext = /*#__PURE__*/ (0, _react.createContext)({});
const treeViewWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let height = false;
    let minWidth = false;
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "F") height = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma171';
    if (!height) rules += ' Fb171';
    if (!minWidth) rules += ' N3HJbhc171';
    rules += ' sd171';
    rules += ' _Bb171';
    rules += ' __ca171';
    if (!position) rules += ' _Pc171';
    rules += ' _Nb171';
    rules += ' Pb171';
    rules += ' -dBGRde-ZSOzjZb171';
    rules += ' -qVUQke-oR3ltQc171';
    return rules;
};
// TODO: can't use border cuz it means the contents of the tree are no longer
// flush with its container. Outline and box shadow are affected by the outlineOffset we
// have in the tree styles and result in the rows clipping the drop outline. This approach
// avoids that
const rootDropOutline = "_2RDoQb";
// These are the same as ListView. we didn't have v3 tree dnd and dont have designs so to be adjusted later
const dropTargetBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const rootDropSelectedRowBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 28%)]";
const rowDropBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const rootRowDropStyles = {
    default: dropTargetBackground,
    isSelected: rootDropSelectedRowBackground,
    forcedColors: 'Background'
};
const rowDropStyles = {
    default: rowDropBackground,
    isSelected: rowDropBackground,
    forcedColors: 'Background'
};
// TODO: the below is needed so the borders of the top and bottom row isn't cut off if the TreeView is wrapped within a container by always reserving the 2px needed for the
// keyboard focus ring. Perhaps find a different way of rendering the outlines since the top of the item doesn't
// scroll into view due to how the ring is offset. Alternatively, have the tree render the top/bottom outline like it does in Listview
const tree = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kb171';
    rules += ' _4c171';
    rules += ' Ma171';
    rules += ' Na171';
    rules += ' Za171';
    rules += ' Fb171';
    rules += ' _Na171';
    rules += ' Pa171';
    rules += ' _oa171';
    if (props.isDropTarget) {
        rules += ' glzvDBe171';
        rules += ' glOVIhfcceMNLe171';
        rules += ' glOVIhfcceMNLe171';
    }
    if (props.isEmpty) rules += ' _Ca171';
    if (props.isEmpty) rules += ' eb171';
    rules += ' -lPUMEc-ZxhYlec171';
    return rules;
};
let InternalTreeViewContext = /*#__PURE__*/ (0, _react.createContext)({});
const TreeView = /*#__PURE__*/ (0, _react.forwardRef)(function TreeView(props, ref) {
    let { children, selectionStyle = 'checkbox', UNSAFE_className, UNSAFE_style, dragAndDropHooks } = props;
    let scale = (0, _utils.useScale)();
    if (dragAndDropHooks && dragAndDropHooks.renderDragPreview == null) dragAndDropHooks.renderDragPreview = (items)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragPreview.DragPreview), {
            items: items
        });
    let hasCheckbox = props.selectionMode !== 'none' && selectionStyle !== 'highlight';
    if (dragAndDropHooks) dragAndDropHooks.renderDropIndicator = (target)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dndUtils.InsertionIndicator), {
            target: target
        });
    let renderer;
    if (typeof children === 'function') renderer = children;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let scrollRef = (0, _react.useRef)(null);
    let { selectedKeys, onSelectionChange, actionBar, actionBarHeight } = (0, _actionBar.useActionBarContainer)({
        ...props,
        scrollRef
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: domRef,
        className: (UNSAFE_className ?? '') + treeViewWrapper({
            hasCheckbox
        }, props.styles) + ' ' + rootDropOutline,
        style: UNSAFE_style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _virtualizer.Virtualizer), {
                layout: (0, _listView.S2ListLayout),
                layoutOptions: {
                    rowHeight: scale === 'large' ? 50 : 40,
                    dropIndicatorThickness: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TreeRendererContext.Provider, {
                    value: {
                        renderer
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTreeViewContext.Provider, {
                        value: {
                            selectionStyle
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
                            ...props,
                            dragAndDropHooks: dragAndDropHooks,
                            style: {
                                paddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0,
                                scrollPaddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0
                            },
                            className: (renderProps)=>tree(renderProps),
                            selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                            selectedKeys: selectedKeys,
                            defaultSelectedKeys: undefined,
                            onSelectionChange: onSelectionChange,
                            ref: scrollRef,
                            children: props.children
                        })
                    })
                })
            }),
            actionBar
        ]
    });
});
const rowBackgroundColor = {
    default: '--s2-container-bg',
    isFocusVisibleWithin: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isSelected: {
        default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
        isFocusVisibleWithin: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
        isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
        isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]"
    },
    forcedColors: {
        default: 'Background'
    }
};
const treeRow = function anonymous(props) {
    let rules = " ";
    if (props.isDropTarget) rules += ' _Lf171';
    else rules += ' _Le171';
    if (props.isDropTarget) rules += ' _Mc171';
    if (props.isDropTarget) rules += ' _Kb171';
    if (props.isDropTarget) rules += ' Oh171';
    if (props.isDropTarget) rules += ' OlOVIhfcebS7sd171';
    if (props.isDropTarget) rules += ' OlOVIhfcebS7sd171';
    rules += ' _Pc171';
    rules += ' sd171';
    rules += ' F3JjxG171';
    rules += ' Za171';
    rules += ' _oa171';
    rules += ' uk171';
    rules += ' ucJ9TBTb171';
    rules += ' ud3Euai171';
    rules += ' uea171';
    rules += ' ugb171';
    rules += ' uhd171';
    rules += ' uje171';
    rules += ' u2NhKxcl171';
    rules += ' uic171';
    rules += ' -_6BNtrc-c171';
    rules += ' vFHT6Dd171';
    rules += ' xb171';
    rules += ' _xa171';
    rules += ' _Fd171';
    rules += ' _FnuYUweb171';
    if (props.isSelected) {
        if (props.isPressed) rules += ' po171';
        else if (props.isFocusVisible) rules += ' po171';
        else if (props.isHovered) rules += ' po171';
        else rules += ' pt171';
    } else {
        if (props.isPressed) rules += ' pt171';
        else if (props.isFocusVisible) rules += ' pt171';
        else if (props.isHovered) rules += ' pt171';
        else rules += ' pv171';
    }
    rules += ' plOVIhfc6LxY9171';
    rules += ' plOVIhfc6LxY9171';
    if (props.isLink) rules += ' ry171';
    else rules += ' ri171';
    if (props.isSelected) {
        if (props.isPressed) rules += ' -qH4xad-gRfT7e171';
        else if (props.isHovered) rules += ' -qH4xad-gRfT7e171';
        else if (props.isFocusVisibleWithin) rules += ' -qH4xad-gRfT7e171';
        else rules += ' -qH4xad-gj1B7i171';
    } else if (props.isPressed) rules += ' -qH4xad-gj1B7i171';
    else if (props.isHovered) rules += ' -qH4xad-gj1B7i171';
    else if (props.isFocusVisibleWithin) rules += ' -qH4xad-gj1B7i171';
    else rules += ' -qH4xad-gEzkoQe171';
    rules += ' -qH4xad-lOVIhfcgceMNLe171';
    rules += ' -qH4xad-lOVIhfcgceMNLe171';
    rules += ' -_8Gqznb-oR3ltQc171';
    rules += ' oR3ltQc171';
    rules += ' nR3ltQc171';
    rules += ' kR3ltQc171';
    rules += ' jR3ltQc171';
    return rules;
};
const treeCellGrid = function anonymous(props) {
    let rules = " ";
    rules += ' se171';
    rules += ' Za171';
    rules += ' Fb171';
    rules += ' _oa171';
    rules += ' oR3ltQc171';
    rules += ' nR3ltQc171';
    rules += ' kR3ltQc171';
    rules += ' jR3ltQc171';
    rules += ' _cb171';
    rules += ' eb171';
    rules += ' DGwsyMe171';
    rules += ' EM8Mfn171';
    rules += ' C4pAWc171';
    rules += ' Rp171';
    if (props.selectionStyle === "highlight") {
        if (props.isSelected) {
            rules += ' plOVIhfcgp5Dcd171';
            rules += ' plOVIhfcgp5Dcd171';
        }
    } else {
        if (props.isDisabled) rules += ' pp171';
        rules += ' plOVIhfc6LxY9171';
        rules += ' plOVIhfc6LxY9171';
    }
    if (props.isFocusVisible) rules += ' -_7xg3bb-Oh171';
    else rules += ' -_7xg3bb-O8Izf8c171';
    rules += ' -_7xg3bb-lOVIhfcOebS7sd171';
    rules += ' -_7xg3bb-lOVIhfcOebS7sd171';
    rules += ' -pKMv1c-Oh171';
    rules += ' -pKMv1c-lOVIhfcOebS7sd171';
    rules += ' -pKMv1c-lOVIhfcOebS7sd171';
    if (props.selectionStyle === "highlight") rules += ' -EH8uVb-iw171';
    else rules += ' -EH8uVb-iA171';
    rules += ' -EH8uVb-lOVIhfciCp4usd171';
    rules += ' -EH8uVb-lOVIhfciCp4usd171';
    rules += ' _yb171';
    return rules;
};
const treeRowBackground = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa171';
    rules += ' _9a171';
    rules += ' Wr171';
    rules += ' _lr171';
    rules += ' _Ar171';
    rules += ' _zr171';
    if (props.isDropTarget) {
        if (props.isSelected) rules += ' glzvDBe171';
        else rules += ' glzvDBe171';
        rules += ' glOVIhfcceMNLe171';
        rules += ' glOVIhfcceMNLe171';
    } else {
        if (props.selectionStyle === "highlight") {
            if (props.isSelected) {
                if (props.isFocusVisible) rules += ' gaZwDBe171';
                else if (props.isPressed) rules += ' gaZwDBe171';
                else if (props.isHovered) rules += ' gaZwDBe171';
                else rules += ' glzvDBe171';
                rules += ' glOVIhfcebS7sd171';
                rules += ' glOVIhfcebS7sd171';
            } else rules += ' gs9yXOb171';
        } else {
            rules += ' gs9yXOb171';
            rules += ' glOVIhfcceMNLe171';
            rules += ' glOVIhfcceMNLe171';
        }
        if (props.isSelected) rules += ' gRQwW1ubHDBe171';
        else rules += ' gRQwW1lzvDBe171';
        rules += ' gRQwW1lOVIhfcceMNLe171';
        rules += ' gRQwW1lOVIhfcceMNLe171';
    }
    if (props.isPreviousSelected) {
        if (props.isSelected) rules += ' od171';
        else rules += ' o4VHKAc171';
    } else rules += ' o4VHKAc171';
    if (props.isPreviousSelected) {
        if (props.isSelected) rules += ' nd171';
        else rules += ' n4VHKAc171';
    } else rules += ' n4VHKAc171';
    if (props.isNextSelected) {
        if (props.isSelected) rules += ' kd171';
        else rules += ' k4VHKAc171';
    } else rules += ' k4VHKAc171';
    if (props.isNextSelected) {
        if (props.isSelected) rules += ' jd171';
        else rules += ' j4VHKAc171';
    } else rules += ' j4VHKAc171';
    if (props.isPreviousSelected) rules += ' _ka171';
    else rules += ' _kb171';
    if (props.isNextSelected) rules += ' ha171';
    else rules += ' hb171';
    rules += ' mb171';
    rules += ' lb171';
    rules += ' _jf171';
    if (props.isSelected) rules += ' i4pzfu171';
    else rules += ' iA171';
    return rules;
};
const treeCheckbox = function anonymous(props) {
    let rules = " ";
    rules += ' zoRzcu171';
    rules += ' yoRzcu171';
    rules += ' BoRzcu171';
    rules += ' AoRzcu171';
    rules += ' IH5kTnc171';
    rules += ' HYB8I171';
    rules += ' Rd171';
    if (props.isDisabled) rules += ' _6b171';
    else rules += ' _6c171';
    return rules;
};
const treeIcon = " z2U5Crc171 y2U5Crc171 B2U5Crc171 A2U5Crc171 Ht171 Hsu171 -_8sjo0b-t5ZbAob171";
const treeContent = " zk52g2d171 yk52g2d171 Bk52g2d171 Ak52g2d171 _Yb171 _7c171 _Nc171 Pc171";
const treeActions = " zkG38H171 ykG38H171 BkG38H171 AkG38H171 Iahikk171 HR3ltQc171";
const treeActionMenu = " z6Nrfjc171 y6Nrfjc171 B6Nrfjc171 A6Nrfjc171";
const treeDragButtonContainer = " zqEWDzc171 yqEWDzc171 BqEWDzc171 AqEWDzc171 sd171 eb171 _Ca171 ZDldWXb171";
let treeRowFocusRing = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    if (props.selectionStyle === "highlight") {
        rules += ' Oh171';
        rules += ' OlOVIhfcCp4usd171';
        rules += ' OlOVIhfcCp4usd171';
    } else {
        rules += ' Oh171';
        rules += ' OlOVIhfcebS7sd171';
        rules += ' OlOVIhfcebS7sd171';
    }
    rules += ' _Mc171';
    rules += ' _MlOVIhfckNNfn171';
    rules += ' _MlOVIhfckNNfn171';
    rules += ' _Kb171';
    rules += ' _KlOVIhfcToPtrc171';
    rules += ' _KlOVIhfcToPtrc171';
    rules += ' _Pa171';
    if (props.isFirstItem) rules += ' Wr171';
    else rules += ' WLPOtrc171';
    if (props.selectionStyle === "highlight") {
        if (props.isSelected) {
            if (props.isNextSelected) rules += ' _lr171';
            else rules += ' _lr171';
        } else if (props.isNextSelected) rules += ' _lLPOtrc171';
        else rules += ' _lr171';
    } else if (props.selectionStyle === "checkbox") rules += ' _lr171';
    rules += ' _Ar171';
    rules += ' _zr171';
    rules += ' oR3ltQc171';
    rules += ' nR3ltQc171';
    rules += ' kR3ltQc171';
    rules += ' jR3ltQc171';
    rules += ' _9c171';
    rules += ' _Ob171';
    return rules;
};
const TreeViewItem = (props)=>{
    let { href } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
        ...props,
        className: (renderProps)=>treeRow({
                ...renderProps,
                isLink: !!href
            })
    });
};
const TreeViewItemContent = (props)=>{
    let { children } = props;
    let scale = (0, _utils.useScale)();
    let { selectionStyle } = (0, _react.useContext)(InternalTreeViewContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItemContent), {
        children: ({ isExpanded, hasChildItems, selectionMode, selectionBehavior, isDisabled, isSelected, id, state, isHovered, isFocusVisible, isFocusVisibleWithin, allowsDragging, isDropTarget })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: treeCellGrid({
                    isDisabled,
                    isNextSelected: isNextSelected(id, state),
                    isSelected,
                    selectionStyle
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: treeRowBackground({
                            isHovered,
                            isFocusVisible,
                            isSelected,
                            selectionStyle,
                            isNextSelected: isNextSelected(id, state),
                            isPreviousSelected: isPrevSelected(id, state),
                            isDropTarget
                        })
                    }),
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: treeRowFocusRing({
                            isFocusVisible,
                            selectionStyle,
                            isSelected,
                            isNextSelected: isNextSelected(id, state),
                            isFirstItem: isFirstItem(id, state)
                        })
                    }),
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: treeDragButtonContainer,
                        children: !isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dndUtils.DragHandleButton), {
                            isFocusVisibleWithin: isFocusVisibleWithin
                        })
                    }),
                    selectionMode !== 'none' && selectionBehavior === 'toggle' && selectionStyle !== 'highlight' && // TODO: add transition?
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: treeCheckbox({
                            isDisabled: isDisabled || !state.selectionManager.canSelectItem(id) || state.disabledKeys.has(id)
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                            slot: "selection"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " z7fSmKc171 y7fSmKc171 B7fSmKc171 A7fSmKc171 ZecPNad171"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandableRowChevron, {
                        isDisabled: isDisabled,
                        isExpanded: isExpanded,
                        scale: scale,
                        isHidden: !hasChildItems
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                        values: [
                            [
                                (0, _content.TextContext),
                                {
                                    styles: treeContent
                                }
                            ],
                            [
                                (0, _icon.IconContext),
                                {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: treeIcon
                                    }),
                                    styles: " ZObNfn171 FObNfn171 _va171"
                                }
                            ],
                            [
                                (0, _actionButtonGroup.ActionButtonGroupContext),
                                {
                                    styles: treeActions,
                                    isDisabled
                                }
                            ],
                            [
                                (0, _actionMenu.ActionMenuContext),
                                {
                                    styles: treeActionMenu,
                                    isQuiet: true,
                                    isDisabled
                                }
                            ]
                        ],
                        children: typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            children: children
                        }) : children
                    })
                ]
            });
        }
    });
};
const centeredWrapper = " sd171 eb171 _Ca171 Za171 Fb171";
const TreeViewLoadMoreItem = (props)=>{
    let { loadingState, onLoadMore } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeLoadMoreItem), {
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        className: " Za171 JR3ltQc171 GR3ltQc171",
        children: ()=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: centeredWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('table.loadingMore')
                })
            });
        }
    });
};
const expandButton = function anonymous(props) {
    let rules = " ";
    rules += ' z8dW5Qb171';
    rules += ' y8dW5Qb171';
    rules += ' B8dW5Qb171';
    rules += ' A8dW5Qb171';
    if (props.isDisabled) {
        rules += ' pp171';
        rules += ' plOVIhfcYMPQu171';
        rules += ' plOVIhfcYMPQu171';
    } else rules += ' p40ub4c171';
    rules += ' F3JjxG171';
    rules += ' Z3JjxG171';
    rules += ' sd171';
    rules += ' _wb171';
    rules += ' _cb171';
    rules += ' _Ca171';
    rules += ' _Le171';
    rules += ' ri171';
    if (props.isExpanded) {
        if (props.isRTL) rules += ' _Za171';
        else rules += ' _Zb171';
    }
    rules += ' Td171';
    rules += ' Qd171';
    rules += ' Sd171';
    rules += ' Rd171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    rules += ' g9171';
    rules += ' _je171';
    rules += ' __ca171';
    if (props.isHidden) rules += ' _6b171';
    return rules;
};
function ExpandableRowChevron(props1) {
    let expandButtonRef = (0, _react.useRef)(null);
    let [fullProps, ref] = (0, _slots.useContextProps)({
        ...props1,
        slot: 'chevron'
    }, expandButtonRef, (0, _button.ButtonContext));
    let { isExpanded, scale, isHidden } = fullProps;
    let { direction } = (0, _i18Nprovider.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...props1,
        ref: ref,
        slot: "chevron",
        className: (renderProps)=>expandButton({
                ...renderProps,
                isExpanded,
                isRTL: direction === 'rtl',
                scale,
                isHidden
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
            className: function anonymous(props) {
                let rules = " ";
                if (props.direction === "rtl") {
                    rules += ' -Z4Pn4c-a171';
                    rules += ' __Ha171';
                } else if (props.direction === "ltr") {
                    rules += ' -Z4Pn4c-b171';
                    rules += ' __Ha171';
                }
                if (props.direction === "rtl") {
                    rules += ' -_04Pn4c-a171';
                    rules += ' __Ha171';
                } else if (props.direction === "ltr") {
                    rules += ' -_04Pn4c-b171';
                    rules += ' __Ha171';
                }
                rules += ' -_8sjo0b-t5ZbAob171';
                return rules;
            }({
                direction
            })
        })
    });
}
function isNextSelected(id, state) {
    if (id == null || !state) return false;
    let keyAfter = state.collection.getKeyAfter(id);
    // We need to skip non-item nodes because the selection manager will map non-item nodes to their parent before checking selection
    let node = keyAfter != null ? state.collection.getItem(keyAfter) : null;
    while(node && node.type !== 'item' && keyAfter != null){
        keyAfter = state.collection.getKeyAfter(keyAfter);
        node = keyAfter != null ? state.collection.getItem(keyAfter) : null;
    }
    return keyAfter != null && state.selectionManager.isSelected(keyAfter);
}
function isPrevSelected(id, state) {
    if (id == null || !state) return false;
    let keyBefore = state.collection.getKeyBefore(id);
    return keyBefore != null && state.selectionManager.isSelected(keyBefore);
}
function isFirstItem(id, state) {
    if (id == null || !state) return false;
    return state.collection.getFirstKey() === id;
}

},{"0":"kfhuw","1":"3iwSx","2":"kDAtl","3":"9JGbW","4":"9z357","5":"3HGyl","6":"f3LRf","7":"aEzVn","8":"iXfL8","9":"84U11","10":"8ZRVs","11":"mQ3I5","12":"g8YtD","13":"eF2zk","14":"SUUo3","15":"hbRen","16":"6HT6y","17":"3OINs","18":"3GQAK","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","./ActionMenu":"3fSPo","react-aria-components/Button":"9G5XO","./CenterBaseline":"1vpL9","./Checkbox":"jdSVu","../ui-icons/Chevron":"1904U","./dnd-utils":"942YI","./DragPreview":"cHtqj","./Icon":"jQAJE","../intl/*.json":"gDH3q","./ProgressCircle":"dztOy","react-aria-components/slots":"bA6Cz","react-aria-components/Tree":"kwlwT","react":"a1TxN","./ListView":"7zybe","./Content":"10r6w","./ActionBar":"gU4lG","./useDOMRef":"9tqah","react-aria/I18nProvider":"l34Wn","react-aria/useLocalizedStringFormatter":"4LM0k","./utils":"9papc","react-aria-components/Virtualizer":"2WSF6","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kfhuw":[function() {},{}],"3iwSx":[function() {},{}],"kDAtl":[function() {},{}],"9JGbW":[function() {},{}],"9z357":[function() {},{}],"3HGyl":[function() {},{}],"f3LRf":[function() {},{}],"aEzVn":[function() {},{}],"iXfL8":[function() {},{}],"84U11":[function() {},{}],"8ZRVs":[function() {},{}],"mQ3I5":[function() {},{}],"g8YtD":[function() {},{}],"eF2zk":[function() {},{}],"SUUo3":[function() {},{}],"hbRen":[function() {},{}],"6HT6y":[function() {},{}],"3OINs":[function() {},{}],"3GQAK":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ActionBar.4979f70b.js.map
